import { Link } from 'react-router-dom'
import {
  Building2,
  Home,
  KeyRound,
  Lightbulb,
  Sparkles,
} from 'lucide-react'
import { useCityStore } from '@/store/cityStore'
import { PATHS } from '@/routes/paths'
import { buildPropertyHref } from '@/lib/propertyNavLinks'

const services = [
  { label: 'Buy', icon: Home, href: (city: string) => buildPropertyHref('buy', { city }) },
  { label: 'Rent', icon: KeyRound, href: (city: string) => buildPropertyHref('rent', { city }) },
  { label: 'Projects', icon: Building2, href: (city: string) => buildPropertyHref('buy', { city, categorySlug: 'new-project', category: 'New Project' }) },
  { label: 'Premium', icon: Sparkles, href: () => PATHS.premium },
  { label: 'Insights', icon: Lightbulb, href: () => PATHS.blog },
] as const

export function HeroMobileServices() {
  const { cityName } = useCityStore()
  const city = cityName.toLowerCase()

  return (
    <div className="border-b border-neutral-100 bg-white py-2.5 md:hidden">
      <div className="grid grid-cols-5 gap-1 px-2">
        {services.map(({ label, icon: Icon, href }) => (
          <Link
            key={label}
            to={href(city)}
            className="flex flex-col items-center gap-1 py-0.5 text-center"
          >
            <Icon className="h-6 w-6 text-primary-600" strokeWidth={1.75} />
            <span className="text-[10px] font-semibold leading-tight text-neutral-800">{label}</span>
          </Link>
        ))}
      </div>
    </div>
  )
}
